import React, { useState } from "react";

const LocationSearch = ({ onSearch, onGeolocate, onCurrentLocation, loading, error, value, onChange, isCurrentLocation, isDefaultLocation }) => {
  const [input, setInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      onSearch(input.trim());
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center justify-center w-full mb-10"
    >
      <div className="relative w-full max-w-7xl">
        {/* Search Icon */}
        <span className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
            />
          </svg>
        </span>
        <input
          type="text"
          className="w-full border border-[#4A5567] h-16 pl-14 pr-16 rounded-xl bg-[#364153] text-white placeholder-gray-200 text-lg focus:outline-none shadow-md"
          placeholder="Search for location"
          value={input}
          onChange={e => { setInput(e.target.value); onChange && onChange(e.target.value); }}
          disabled={loading}
        />
        {/* Current Location Button */}
        <button
          type="button"
          className={`absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full transition ${
            isCurrentLocation
              ? 'bg-green-500 hover:bg-green-600'
              : isDefaultLocation
              ? 'bg-yellow-500 hover:bg-yellow-600'
              : 'bg-secondary hover:bg-indigo-600'
          } focus:outline-none focus:ring-2 focus:ring-indigo-400`}
          onClick={onCurrentLocation}
          disabled={loading}
          aria-label="Use current location"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        </button>
        {error && <div className="absolute left-0 -bottom-7 text-red-400 text-sm">{error}</div>}
      </div>
    </form>
  );
};

export default LocationSearch; 
